import { useQuery } from 'react-query';
import OrdersApi from '../../../../../OrdersApi';
import { getUserInfo } from '../../../../../../../telemetry/utils';
import { useTelemetryContext } from '../../../../../../../telemetry/telemetryContext';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import * as ArchiveStatus from '../../../../../../../shared/ArchiveStatus';

type ArchiveQueryArgs = {
    orderId: number;
    user: AuthenticatedUser;
};

type ArchiveQueryResult = {
    isPreArchived: boolean | null;
    isLoading: boolean;
};

export let archiveStatusQueryKey = 'image-editor-archive-status';

export function useArchiveCheckQuery({ orderId, user }: ArchiveQueryArgs): ArchiveQueryResult {
    let { logger } = useTelemetryContext();

    let { data: archiveStatus, isLoading } = useQuery(
        [archiveStatusQueryKey, { orderId }],
        () => OrdersApi.checkIfOrderIsArchived(orderId),
        {
            useErrorBoundary: true,
            onError: (error) => {
                let additionalInfo = {
                    origin: 'ImageEditorImageProcessingPage.Query.checkIfOrderIsArchived',
                    userInfo: getUserInfo(user)
                };
                logger.logException(error, additionalInfo);
            }
        }
    );

    if (isLoading || !archiveStatus) {
        return { isPreArchived: null, isLoading: true };
    }

    let isPreArchived =
        archiveStatus.photoIsPreArchived &&
        archiveStatus.archivedStatus < ArchiveStatus.ArchivedGlacier;

    return { isPreArchived, isLoading: false };
}
